import React from "react";
import { InputField, ReactSelect, required, ToggleField } from "modules/4_final_form/web";
import { Fragment } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import { Field, useFormState } from "react-final-form";

export const getColsAttributes = (values, position) => {
  const latest_revision = _.last(values?.revisions_attributes);
  let pages_attributes = latest_revision?.pages_attributes;
  if (position) {
    pages_attributes = _.filter(pages_attributes, (p) => p.position <= position);
  }
  const data = _.flatMap(pages_attributes, "data");
  const rows_attributes = _.flatMap(data, "rows_attributes");
  const cols_attributes = _.flatMap(rows_attributes, "cols_attributes");
  return _.compact(cols_attributes);
};

export const conditionalCheck = (
  column_type,
  conditional_value_required,
  conditional_select_value_required,
  conditional_boolean_value,
  current_input_value
) => {
  let check = false;
  if (column_type == "toggle") {
    check = current_input_value != conditional_boolean_value;
  } else if (_.isArray(conditional_select_value_required)) {
    const conditional_values = _.map(conditional_select_value_required, (v) => v.label.toLowerCase());
    if (_.some(conditional_values, "Present")) {
      check = !_.isNotEmpty(current_input_value);
    } else {
      check = !conditional_values.includes(current_input_value?.toLowerCase());
    }
  } else {
    check = conditional_value_required != conditionalValue;
  }

  return check;
};

export const ConditionalFieldsInputs = (props) => {
  const { revisionIndex, position, uid, conditional_field_name, conditional_selected_name, conditional_boolean_name, conditional_value_name } = props;

  const formState = useFormState();

  let pagesToCheck = formState.values.revisions_attributes[revisionIndex]?.pages_attributes;
  if (position) {
    pagesToCheck = _.filter(pagesToCheck, (p) => p.position < position);
  }

  const data = _.flatMap(pagesToCheck, "data");
  const rows_attributes = _.flatMap(data, "rows_attributes");
  const cols_attributes = _.flatMap(rows_attributes, "cols_attributes");
  const filteredColsAttributes = _.filter(cols_attributes, (c) => c?.uid != uid && !c?._destroy);
  const AllowedConditonalFields = _.filter(
    _.compact(filteredColsAttributes),
    (c) => c.column_type != "text" && c.column_type != "attachments" && c.column_type != "project_variation" && c.column_type != "alert"
  );

  const ConditionalField = _.get(formState.values, conditional_field_name);
  const ConditionalFieldObject = _.find(filteredColsAttributes, { name: ConditionalField });
  let conditions = [{ label: "Present", value: "present" }];
  if (ConditionalFieldObject?.column_type == "toggle") {
    conditions = [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ];
  }
  if (ConditionalFieldObject?.column_type == "yesnona") {
    conditions = [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "N/A", value: "N/A" },
    ];
  }
  const isSelect = ConditionalFieldObject && (ConditionalFieldObject.column_type == "select" || ConditionalFieldObject.column_type == "multiselect");
  const isToggle = ConditionalFieldObject && ConditionalFieldObject.column_type == "toggle";
  const isYesNoNa = ConditionalFieldObject && ConditionalFieldObject.column_type == "yesnona";
  const isProject = ConditionalFieldObject && ConditionalFieldObject.column_type == "project";

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Condition Field</Label>
        <Col md={8}>
          <Field
            name={conditional_field_name}
            component={ReactSelect}
            options={_.map(AllowedConditonalFields, (ca) => {
              return { label: ca.label, value: ca.name };
            })}
            validate={required}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Condition Value</Label>
        <Col md={8}>
          {isSelect && (
            <Field
              component={ReactSelect}
              name={conditional_selected_name}
              multi
              options={_.map(ConditionalFieldObject?.options, (o) => ({ label: o.value, value: o.value }))}
              parse={(value) => (_.isArray(value) ? value : [])}
            />
          )}
          {isYesNoNa && (
            <Field
              component={ReactSelect}
              name={conditional_selected_name}
              multi
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
                { label: "N/A", value: "N/A" },
              ]}
              parse={(value) => (_.isArray(value) ? value : [])}
            />
          )}
          {isToggle && <Field component={ToggleField} name={conditional_boolean_name} />}
          {!isSelect && !isToggle && !isYesNoNa && !isProject && <Field component={InputField} name={conditional_value_name} parse={(v) => v} />}
        </Col>
      </FormGroup>
    </Fragment>
  );
};
